import React, { useState } from 'react'
import styled from 'styled-components'
import { Button } from '@giphy/react-giphy-brand'
import TitleInput from './input'

const Wrap = styled.div`
    display: flex;
    flex-direction: row;
`

type Props = {
    className: string
    value: string
    onChange?: Function
}

const EditPanelVideoTitle = ({ className, value, onChange = () => {} }: Props) => {
    const initialValue = value
    const [text, setText] = useState(initialValue)

    return (
        <div className={className}>
            <span>Video Title</span>
            <Wrap>
                <TitleInput value={text} onChange={value => setText(value)} />
                <Button disabled={text === initialValue} onClick={() => onChange(text)}>
                    Save
                </Button>
            </Wrap>
        </div>
    )
}
export default EditPanelVideoTitle
